/* FURTAGE Showroom-Termin (sections/furtage-showroom-booking.liquid)
   1. Wunschdatum frühestens heute (Datum des Geräts, falls die Seite aus dem Cache kommt).
   2. ?stueck=HANDLE hakt das Stück an und stellt es an den Anfang der Liste. */
if (!customElements.get('furtage-showroom-booking')) {
  customElements.define(
    'furtage-showroom-booking',
    class FurtageShowroomBooking extends HTMLElement {
      connectedCallback() {
        const now = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
        this.querySelectorAll('input[data-min-today]').forEach((input) => {
          input.min = today;
        });

        const handle = new URLSearchParams(window.location.search).get('stueck');
        if (!handle) return;
        const item = Array.from(this.querySelectorAll('[data-piece-handle]')).find(
          (el) => el.dataset.pieceHandle === handle
        );
        if (!item) return;
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = true;
        const list = item.parentElement;
        list.prepend(item);
        list.scrollTop = 0;
      }
    }
  );
}
